import React, { useState } from 'react';
import Form from 'devextreme-react/form';
import {useAuth} from "../../contexts/auth";

export default function OutlookAddin() {
  const {user} = useAuth();

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Get Outlook Add-in</h2>

      <div className={'content-block dx-card responsive-paddings'}>
        <p>
          The Outlook Add-in should be available by default to employees as part of an organisation administration.
          If you can't see <strong>BotX GPT Add-in</strong> in your Outlook, please follow the steps below:
        </p>
      </div>

      <div className={'content-block dx-card responsive-paddings'}>
        <ul>
          <li>1. <a href="https://gpt.azure-youplus-services.com/outlook-addin/manifest.xml" target="_blank" rel="noreferrer" download>Download</a> the BotX GPT Add-in to your computer.</li>
          <li>2. Open your Outlook.</li>
          <li>3. Go to <strong>File</strong> > <strong>Manage Add-ins</strong>, or <strong>Tools</strong> > <strong>Get Add-ins</strong>.</li>
          <li>4. Click on the <strong>My Add-ins</strong> tab.</li>
          <li>5. Click on the <strong>Upload My Add-in</strong> button or <strong>Add a custom add-in</strong> > <strong>Add from File...</strong> </li>
          <li>6. Select the BotX GPT Add-in file you downloaded in step 1 (file name "manifest.xml").</li>
          <li>7. Click <strong>Install</strong> when prompted.</li>
          <li>8. The BotX GPT Add-in should now be available in your Outlook from a toolbar. Please note, the toolbar button is only available when composing an email. The add-in is not visible by default if you're only reading emails.</li>
        </ul>
      </div>
    </React.Fragment>
  );
}